/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { NSABaseServer } from "namirasoft-account";
import { NamirasoftSlackSenderServerChannelBot } from "./NamirasoftSlackSenderServerChannelBot";
import { NamirasoftSlackSenderServerHealthz } from "./NamirasoftSlackSenderServerHealthz";
import { NamirasoftSlackSenderServerProvider } from "./NamirasoftSlackSenderServerProvider";
import { NamirasoftSlackSenderServerProviderCategory } from "./NamirasoftSlackSenderServerProviderCategory";
import { NamirasoftSlackSenderServerProviderField } from "./NamirasoftSlackSenderServerProviderField";
import { NamirasoftSlackSenderServerProviderTag } from "./NamirasoftSlackSenderServerProviderTag";
import { NamirasoftSlackSenderServerSent } from "./NamirasoftSlackSenderServerSent";
import { NamirasoftSlackSenderServerSlack } from "./NamirasoftSlackSenderServerSlack";
import { NamirasoftSlackSenderServerValue } from "./NamirasoftSlackSenderServerValue";
import { TokenManager } from "namirasoft-account";

export class NamirasoftSlackSenderServer extends NSABaseServer
{
    healthz: NamirasoftSlackSenderServerHealthz;
    value: NamirasoftSlackSenderServerValue;
    provider_category: NamirasoftSlackSenderServerProviderCategory;
    provider_field: NamirasoftSlackSenderServerProviderField;
    provider_tag: NamirasoftSlackSenderServerProviderTag;
    slack: NamirasoftSlackSenderServerSlack;
    provider: NamirasoftSlackSenderServerProvider;
    channel_bot: NamirasoftSlackSenderServerChannelBot;
    sent: NamirasoftSlackSenderServerSent;
    constructor(base_url: string, manager: TokenManager, onError: (error: Error) => void)
    {
        super(base_url, `1.4.4`, manager, onError);
        this.healthz = new NamirasoftSlackSenderServerHealthz(this);
        this.value = new NamirasoftSlackSenderServerValue(this);
        this.provider_category = new NamirasoftSlackSenderServerProviderCategory(this);
        this.provider_field = new NamirasoftSlackSenderServerProviderField(this);
        this.provider_tag = new NamirasoftSlackSenderServerProviderTag(this);
        this.slack = new NamirasoftSlackSenderServerSlack(this);
        this.provider = new NamirasoftSlackSenderServerProvider(this);
        this.channel_bot = new NamirasoftSlackSenderServerChannelBot(this);
        this.sent = new NamirasoftSlackSenderServerSent(this);
    }
};